import * as Moment from "moment";
import { Department } from "../department";
import { User } from "../user";

/**
 * 診療科コード・職員コードは期限が切れた情報が入っている可能性あるため、
 * ダイアログから選択したタイミングで使ってよい情報かどうかを検証したほうがよさそう
 */
export class VisitHistoryInformation {
  constructor(public visitDateText: string, public department: Department, public doctor: User) {
  }

  /**
   * 文書編集画面では日付の変換は不要なので、WF依頼編集画面向けに必要になったタイミングで変換する
   */
  get visitDate(): Date {
    if (!this.visitDateText) { return null; }
    return Moment(this.visitDateText, "YYYYMMDD").toDate();
  }

  clone(): VisitHistoryInformation {
    return new VisitHistoryInformation(
      this.visitDateText,
      this.department ? this.department.clone() : this.department,
      this.doctor
    );
  }
}
